import { useCallback, useState } from 'react';
import { balanceSnapshotApi } from '../api/balanceSnapshotApi';
import { BalanceSnapshotDto } from '../types/balanceSnapshot.types';
import { useToast } from '@/shared/components/feedback/Toast/ToastContext';
import { ToastType } from '@/shared/components/feedback/Toast/Toast.types';

export const useBalanceSnapshot = () => {
    const { showToast } = useToast();
    const [snapshots, setSnapshots] = useState<BalanceSnapshotDto[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchSnapshots = useCallback(async (date: string) => {
        try {
            setLoading(true);
            const response = await balanceSnapshotApi.getSnapshotList(date);
            setSnapshots(response.snapshots);
        } catch {
            showToast('잔액 스냅샷 데이터를 불러오는데 실패했습니다.', { type: ToastType.ERROR });
            setSnapshots([]);
        } finally {
            setLoading(false);
        }
    }, [showToast]);

    return {
        snapshots,
        loading,
        fetchSnapshots,
    };
};
